import { Action, ActionReducer } from '@ngrx/store';

/**
 * NgRx state is kept in memory only. Server catalog data is loaded via effects after login.
 * Legacy `app_storage` localStorage hydration was removed to avoid stale forms/tags/attributes.
 */
export function storageMetaReducer<S, A extends Action = Action>(
  reducer: ActionReducer<S, A>
): ActionReducer<S, A> {
  return reducer;
}
